import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aca9d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = { class: "col-auto minimal-stock-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_ctx.AbilityContext.isAuthorizedForFeature('PRODUCT_MINIMAL_STOCK'))
    ? (_openBlock(), _createBlock(_component_BaseCard, {
        key: 0,
        class: "text-bg-light border-light mb-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('minimalStock')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_GenericFormWrapper, {
                pageUI: _ctx.pageUI,
                submitData: _ctx.submitData
              }, {
                content: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.minimalStock.min_stock,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minimalStock.min_stock) = $event)),
                          _ctx.onFormDataChanged
                        ],
                        label: _ctx.$t('minimalStock'),
                        name: "minimalStock",
                        min: 0,
                        step: 0.1,
                        rules: "required",
                        errors: errors
                      }, null, 8, ["modelValue", "label", "step", "errors", "onUpdate:modelValue"])
                    ])
                  ])
                ]),
                buttons: _withCtx(() => [
                  _createVNode(_component_BaseDeleteButton, {
                    deleteData: _ctx.deleteData,
                    pageUI: _ctx.pageUI
                  }, null, 8, ["deleteData", "pageUI"])
                ]),
                _: 1
              }, 8, ["pageUI", "submitData"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}